
import { TestDetails as Details } from "../TestDetails";
import { TestDetails as TestDetailsType } from "@/hooks/useTestCreator";

interface TestDetailsSectionProps {
  details: TestDetailsType;
  onChange: (details: TestDetailsType) => void;
}

export const TestDetailsSection = ({ details, onChange }: TestDetailsSectionProps) => {
  return (
    <div className="w-full">
      <Details details={details} onChange={onChange} />
    </div>
  );
};
